export default {
    // 기업은행
    '003': '이용자 비밀번호',
    // 농협
    '011': '자금 이체 비밀번호',
    // 신한은행
    '088': '이체 비밀번호',
    // SC제일은행
    '023': '이체 비밀번호',
    // 제주은행
    '035': '이체 비밀번호',
    // 신협은행
    '048': '자금 이체 비밀번호',
  }
  